import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { UserApiService } from 'projects/bo/src/app/core/services/api/user/user-api.service';
import { UserDto } from 'projects/bo/src/app/core/services/api/user/user.model';
import { LoadingService } from 'projects/bo/src/app/core/services/helpers/loading.service';
import { AccountState } from 'projects/bo/src/app/core/services/states/account.service';
import { catchError, finalize, map, take } from 'rxjs';
import { EMPTY } from 'rxjs/internal/observable/empty';

export const profileResolver: ResolveFn<UserDto> = (route, state) => {
  const userId = route.paramMap.get('id');
  const router = inject(Router);
  const loading = inject(LoadingService);
  const userApi = inject(UserApiService);
  const accountState = inject(AccountState);

  const clientId = accountState.get()?.clientId;
  if (clientId == null || clientId === undefined || !userId) {
    router.navigateByUrl('exception/404');
    return EMPTY;
  }

  loading.show();
  return userApi.GetUserProfile({ clientId, userId }).pipe(
    take(1),
    map(m => {
      if (m?.data?.model) {
        return m.data.model;
      }
      throw new Error();
    }),
    catchError(() => {
      router.navigateByUrl('exception/404');
      return EMPTY;
    }),
    finalize(() => loading.hide())
  );
};
